import { cn } from '../../utils/cn';

/** Internal cover/thumbnail image part — platform-split (`.native.tsx`). */
export interface CardImageProps {
  src: string;
  className?: string;
  /** Load failure — the card falls back to the no-media version. */
  onError?: () => void;
}

/**
 * Web cover image — a plain `<img>` clipped by the parent's rounded frame.
 * `alt=""` on purpose: the card container carries the accessibility label,
 * so the decorative cover stays silent for screen readers.
 *
 * `object-top`: the media slot shows a preview of the deck's source document
 * (first PDF page), so the crop anchors to the top of the page — the title /
 * heading region — instead of centring on the body text.
 */
export function CardImage({ src, className, onError }: CardImageProps) {
  return (
    <img
      src={src}
      alt=""
      draggable={false}
      className={cn('h-full w-full object-cover object-top', className)}
      onError={onError}
    />
  );
}
